import styled, {css} from 'styled-components';

interface ItemProps {
  readonly theme?: string;
}
export const ToolTipArrow = styled.div`
  content: '';
  position: absolute;
  width: 0;
  height: 0;
  border-width: 10px;
  border-style: solid;
  border-color: transparent transparent rgba(64, 69, 76, 1) transparent;
  top: -15px;
  left: 30px;
`;
export const ToolTipContainer = styled.div<ItemProps>`
  z-index: 1;
  position: absolute;
  box-shadow: -2px 4px 8px 0 rgba(0, 0, 0, 0.27);
  top: 85px;
  width: 135px;

  ${props => {
    let theme = '';
    if (props.theme === 'dark') {
      theme = `
      color: rgba(255,255,255,1);font-family: "Proxima Nova"; opacity: 0.88;  
      `;
    }

    return css`
       {
        ${theme}
      }
    `;
  }};
`;
export const ToolTipTitle = styled.span<ItemProps>`
  border-radius: 4px 4px 0 0;
  display: block;
  padding: 8px 12px 5px 12px;
  font-size: 15px;
  font-weight: 600;
  letter-spacing: -0.09px;
  line-height: 22px;
  ${props => {
    let theme = '';
    if (props.theme === 'dark') {
      theme = `
       background-color: rgba(64, 69, 76, 1);
      `;
    }

    return css`
       {
        ${theme}
      }
    `;
  }};
`;

export const ToolTipText = styled.span<ItemProps>`
  border-radius: 0 0 4px 4px;
  padding: 5px 12px 5px 12px;
  display: block;
  color: rgba(255, 255, 255, 1);
  font-family: 'Proxima Nova';
  font-size: 13px;
  letter-spacing: -0.08px;
  line-height: 15px;
  ${props => {
    let theme = '';
    if (props.theme === 'dark') {
      theme = `
         background-color: rgba(67,72,79,1);
      `;
    }

    return css`
       {
        ${theme}
      }
    `;
  }};
`;
